export function showMouse() {
  const mouse = document.querySelector("#mouse-go-to-scroll");
  if (mouse) {
    mouse.classList.remove("mouse-fadeout");
    mouse.style.display = "flex";
  }
}

export function hideMouse() {
  const mouse = document.querySelector("#mouse-go-to-scroll");
  if (mouse) {
    mouse.classList.add("mouse-fadeout");
    mouse.style.display = "none";
  }
}
